var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPindropComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.315 15.567C6.129 15.8365 5.825 16 5.5 16C5.1765 16 4.874 15.838 4.688 15.5705L4.6195 15.4735L0.674 8.138C0.233 7.333 0 6.4205 0 5.5C0 2.4675 2.4675 0 5.5 0C8.5325 0 11 2.4675 11 5.5C11 6.4205 10.7675 7.332 10.327 8.1365L6.3805 15.4735L6.315 15.567ZM5.496 14.9925L5.5375 14.93L9.447 7.6615L9.449 7.658C9.8095 7 10 6.2535 10 5.5C10 3.019 7.981 1 5.5 1C3.0185 1 1 3.019 1 5.5C1 6.253 1.1905 6.9995 1.553 7.661L5.496 14.9925Z",
    fill: "#D6DCE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5373_56642",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.315 15.567C6.129 15.8365 5.825 16 5.5 16C5.1765 16 4.874 15.838 4.688 15.5705L4.6195 15.4735L0.674 8.138C0.233 7.333 0 6.4205 0 5.5C0 2.4675 2.4675 0 5.5 0C8.5325 0 11 2.4675 11 5.5C11 6.4205 10.7675 7.332 10.327 8.1365L6.3805 15.4735L6.315 15.567ZM5.496 14.9925L5.5375 14.93L9.447 7.6615L9.449 7.658C9.8095 7 10 6.2535 10 5.5C10 3.019 7.981 1 5.5 1C3.0185 1 1 3.019 1 5.5C1 6.253 1.1905 6.9995 1.553 7.661L5.496 14.9925Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5373_56642)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "matrix(-1 0 0 1 13.5 0)",
    fill: "#D6DCE8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPindropComments);
export default __webpack_public_path__ + "static/media/pindrop-comments.c9004c3889259b199ba0e24a4cd2333a.svg";
export { ForwardRef as ReactComponent };